import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db, auth } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import Login from './pages/Login';
import Signup from './pages/Signup';
import MemberSearch from './pages/MemberSearch';
import Iine from './pages/Iine';
import Inbox from './pages/Inbox';
import Chat from './pages/Chat';
import ProfileEdit from './pages/ProfileEdit';
import CompleteProfile0 from './pages/CompleteProfile0';
import CompleteProfile1 from './pages/CompleteProfile1';
import CompleteProfile2 from './pages/CompleteProfile2';
import CompleteProfile3 from './pages/CompleteProfile3';
import CompleteProfile4 from './pages/CompleteProfile4';
import CompleteProfile5 from './pages/CompleteProfile5';
import CompleteProfile6 from './pages/CompleteProfile6';
import CompleteProfile7 from './pages/CompleteProfile7';
import CompleteProfile8 from './pages/CompleteProfile8';
import CompleteProfile9 from './pages/CompleteProfile9';
import CompleteProfile10 from './pages/CompleteProfile10';
import FilteredMembers from './pages/FilteredMembers';
import Settings from './pages/Settings';
import PrivateRoute from './components/PrivateRoute';
import OtherMemberProfile from './pages/OtherMemberProfile';
import Accountsettings from './pages/Accountsettings';
import AgeVerification from './pages/AgeVerification';
import AdminDashboard from './pages/admin/AdminDashboard';
import SettingPush from './pages/settings/SettingPush';
import SettingMail from './pages/settings/SettingMail';
import SettingPass from './pages/settings/SettingPass';
import SettingAccountDelete from './pages/settings/SettingAccountDelete';
import SettingNotification from './pages/settings/SettingNotification';
import AdminNotification from './pages/admin/AdminNotification';
import AdminBannedUser from './pages/admin/AdminBannedUser';
import AdminInquiry from './pages/admin/AdminInquiry';
import AdminAgeVerification from './pages/admin/AdminAgeVerification';
import NotificationDetail from './pages/settings/NotificationDetail';
import SettingInquiry from './pages/settings/SettingInquiry';
import OtherMemberReport from './pages/OtherMemberReport';
import AdminSuspendUser from './pages/admin/AdminSuspendUser';
import IineNotDisplay from './pages/IineNotDisplay';
import ChatNotDisplay from './pages/settings/ChatNotDisplay';
import CallComponent from './pages/call/CallComponent';
import { CallProvider } from './components/CallContext';
import CallModal from './components/CallModal';
import CallListener from './components/CallListener';
import useNetworkStatus from './hooks/useNetworkStatus';
import CheckoutButton from './components/CheckoutButton';
import LandingPage from './pages/LandingPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import PasswordResetEmail from './pages/PasswordResetEmail';
import PaidServices from './pages/settings/PaidServices';
import CancelSubscription from './pages/settings/CancelSubscription'; // 解約ページのインポート
import AdminBroadcastNotification from './pages/admin/AdminBroadcastNotification';
import AdminSpecificNotification from './pages/admin/AdminSpecificNotification';
import SubscriptionSuccess from './pages/settings/SubscriptionSuccess'; // サブスクリプション成功ページをインポート
import LoadingSpinner from './components/LoadingSpinner';
import GlobalCallListener from './components/GlobalCallListener';
import { useLocation } from 'react-router-dom';



const App = () => {
  const [user, loading] = useAuthState(auth);
  const [isSuspended, setIsSuspended] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false); // 画面遷移のローディング状態
  const location = useLocation();
const isCallPage = location.pathname.startsWith('/call/');


  useEffect(() => {
    const checkSuspendedUser = async () => {
      if (user) {
        const docRef = doc(db, 'suspended_user', user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setIsSuspended(true);
        }
      }
    };

    if (user) {
      checkSuspendedUser();
    }
  }, [user]);

  if (loading) return <LoadingSpinner />;
  if (isSuspended) return <div>使用できません</div>;
  

  return (
    <>
{!isCallPage && <GlobalCallListener />}
        <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/" element={<Navigate to={user ? "/member_search" : "/login"} />} />
      <Route
        path="/member_search/*"
        element={
          <PrivateRoute>
            <MemberSearch />
          </PrivateRoute>
        }
      />
      <Route
        path="/iine"
        element={
          <PrivateRoute>
            <Iine />
          </PrivateRoute>
        }
      />
      <Route
  path="/cancel-subscription"
  element={
    <PrivateRoute>
      <CancelSubscription />
    </PrivateRoute>
  }
/>
<Route
  path="/subscription-success"
  element={
    <PrivateRoute>
      <SubscriptionSuccess />
    </PrivateRoute>
  }
/>

      <Route
        path="/inbox"
        element={
          <PrivateRoute>
            <Inbox />
          </PrivateRoute>
        }
      />
              <Route
          path="/other_member_profile/:id"
          element={
            <PrivateRoute>
              <OtherMemberProfile />
            </PrivateRoute>
          }
        />
      <Route
  path="/member_search/partner/:id"
  element={
    <PrivateRoute>
      <MemberSearch />
    </PrivateRoute>
  }
/>

      <Route
        path="/chat/:chatId"
        element={
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile_edit"
        element={
          <PrivateRoute>
            <ProfileEdit />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile0"
        element={
          <PrivateRoute>
            <CompleteProfile0 />
          </PrivateRoute>
        }
      />
      <Route
        path="/complete-profile1"
        element={
          <PrivateRoute>
            <CompleteProfile1 />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile2"
        element={
          <PrivateRoute>
            <CompleteProfile2 />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile3"
        element={
          <PrivateRoute>
            <CompleteProfile3 />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile4"
        element={
          <PrivateRoute>
            <CompleteProfile4 />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile5"
        element={
          <PrivateRoute>
            <CompleteProfile5 />
          </PrivateRoute>
        }
      />
            <Route
        path="/complete-profile6"
        element={
          <PrivateRoute>
            <CompleteProfile6 />
          </PrivateRoute>
        }
      />
                  <Route
        path="/complete-profile7"
        element={
          <PrivateRoute>
            <CompleteProfile7 />
          </PrivateRoute>
        }
      />
                  <Route
        path="/complete-profile8"
        element={
          <PrivateRoute>
            <CompleteProfile8 />
          </PrivateRoute>
        }
      />
                        <Route
        path="/complete-profile9"
        element={
          <PrivateRoute>
            <CompleteProfile8 />
          </PrivateRoute>
        }
      />
                        <Route
        path="/complete-profile10"
        element={
          <PrivateRoute>
            <CompleteProfile8 />
          </PrivateRoute>
        }
      />
      <Route
        path="/filtered_members"
        element={
          <PrivateRoute>
            <FilteredMembers />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        }
      />
       <Route
          path="/accountsettings"
          element={
            <PrivateRoute>
              <Accountsettings />
            </PrivateRoute>
          }
        />
        <Route
          path="/age_verification"
          element={
            <PrivateRoute>
              <AgeVerification />
            </PrivateRoute>
          }
        />
        <Route
          path="/filtered_members"
          element={
            <PrivateRoute>
              <FilteredMembers />
            </PrivateRoute>
          }
        />
        <Route
          path="/settingpush"
          element={
            <PrivateRoute>
              <SettingPush />
            </PrivateRoute>
          }
        />
        <Route
          path="/settingmail"
          element={
            <PrivateRoute>
              <SettingMail />
            </PrivateRoute>
          }
        />
        <Route
          path="/settingpass"
          element={
            <PrivateRoute>
              <SettingPass />
            </PrivateRoute>
          }
        />
        <Route
          path="/settingaccountdelete"
          element={
            <PrivateRoute>
              <SettingAccountDelete />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/settingnotification"
          element={
            <PrivateRoute>
              <SettingNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminnotification"
          element={
            <PrivateRoute>
              <AdminNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminbanneduser"
          element={
            <PrivateRoute>
              <AdminBannedUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/admininquiry"
          element={
            <PrivateRoute>
              <AdminInquiry />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminageverification"
          element={
            <PrivateRoute>
              <AdminAgeVerification />
            </PrivateRoute>
          }
        />
                <Route
          path="/broadcast-notification"
          element={
            <PrivateRoute>
              <AdminBroadcastNotification />
            </PrivateRoute>
          }
        />
        
        {/* 特定のユーザーへの通知送信ページ */}
        <Route
          path="/specific-notification"
          element={
            <PrivateRoute>
              <AdminSpecificNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/notification/:id"
          element={
            <PrivateRoute>
              <NotificationDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/settinginquiry"
          element={
            <PrivateRoute>
              <SettingInquiry />
            </PrivateRoute>
          }
        />
        <Route
          path="/report/:id"
          element={
            <PrivateRoute>
              <OtherMemberReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/adminsuspenduser"
          element={
            <PrivateRoute>
              <AdminSuspendUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/iine-not-display"
          element={
            <PrivateRoute>
              <IineNotDisplay />
            </PrivateRoute>
          }
        />
        <Route
          path="/chat-not-display"
          element={
            <PrivateRoute>
              <ChatNotDisplay />
            </PrivateRoute>
          }
        />
        <Route
          path="/call/:chatId"
          element={
            <PrivateRoute>
              <CallComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <PrivateRoute>
              <CheckoutButton userId={user ? user.uid : null} />
            </PrivateRoute>
          }
        />
        <Route
          path="/paidservices"
          element={
            <PrivateRoute>
              <PaidServices />
            </PrivateRoute>
          }
        />
                <Route
          path="/terms-of-service"
          element={<TermsOfService />}
        />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/legal-notice"
          element={<LegalNotice />}
        />
        <Route path="/landing" element={<LandingPage />} />

              <Route
          path="*"
          element={<Navigate to={user ? "/member_search" : "/landing"} />}
        />
    </Routes>
  </>
  );
};

export default App;
